import React, { Component } from 'react';
import Pagination from 'react-bootstrap/Pagination'
import Email from './email';
import CompanyIntel from './companyIntel';
import http from '../services/httpService';

const apiEndpoint = 'emails';
const apiEndpointParam = 'pagesize';

class EmailList extends Component {
    state = {
        emails: [],
        meta: {}
    };

    async saveApiResponse(url) {
        const { data: { emails, meta } } = await http.get(url);
        this.setState({ emails });
        this.setState({ meta });
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevProps.filters !== this.props.filters) {
            let filterParams = new URLSearchParams(this.props.filters);
            if (this.props.listSize) {
                filterParams.append(apiEndpointParam, this.props.listSize);
            }
            this.saveApiResponse(apiEndpoint + '?' + filterParams.toString());
        }
    }

    async componentDidMount() {
        this.saveApiResponse(apiEndpoint);
    }

    get_user_type() {
        return this.props.user ? this.props.user.user_type :
            'Free' ;
    }

    // NOTE: Maybe we can show hero image for the first page and if there are no filters?
    shouldShowHeroImage() {
        const user_type = this.get_user_type();
        return user_type === 'Admin' || user_type === 'Enterprise' || 
          user_type === 'Premium' || true;
    }

    shouldShowAdminView() {
        const { user_type } = this.get_user_type();
        return user_type === 'Admin';
    }

    populatePagination() {
        const { page: current_page, pages: total_pages } = this.state.meta; 
        const page_lower_bound = Math.max(current_page - 1, 1),
            page_upper_bound = Math.min(current_page + 1, total_pages);
        let pages = [];
        pages.push(
            <Pagination.First 
                onClick={ this.handlePageChange(1) }
                disabled={ current_page === 1 }
                key="first"
            />
        );
        pages.push(
            <Pagination.Prev 
                onClick={ this.handlePageChange(current_page - 1) }
                disabled={ current_page === 1 }
                key="prev"
            />
        );
        if (current_page > 2) {
            pages.push(
                <Pagination.Ellipsis
                    disabled
                    key="disabled-before"
                />
            )
        }
        for (let i = page_lower_bound; i < (page_upper_bound + 1); i++) {
            pages.push(
                <Pagination.Item 
                    key={i} 
                    active={ i === current_page }
                    onClick={ this.handlePageChange(i) }>
                    {i}
                </Pagination.Item>);
        }
        if (current_page < total_pages - 1) {
            pages.push(
                <Pagination.Ellipsis
                    disabled
                    key="disabled-after"
                />
            )
        }
        pages.push(
            <Pagination.Next 
                onClick={ this.handlePageChange(current_page + 1) }
                disabled={ current_page === total_pages }
                key="next"
            />
        );
        pages.push(
            <Pagination.Last
                onClick={ this.handlePageChange(total_pages) }
                disabled={ current_page === total_pages }
                key="last"
            />
        );

        return pages;
    }

    handlePageChange = page => async () => {
        console.log(this.props.filters);
        let searchParams = new URLSearchParams(this.props.filters);
        searchParams.append('page', page);
        this.saveApiResponse(apiEndpoint + '?' + searchParams.toString())
    };

    render() {
        return (
            <React.Fragment>
                {this.props.showAnalysis && <CompanyIntel emails={ this.state.emails } />}
                <div>
                    { this.state.emails.map(
                        email => <Email 
                                    key={ email.id } 
                                    shouldShowHeroImage={ this.shouldShowHeroImage() } 
                                    shouldShowAdminView={ this.shouldShowAdminView() }
                                    parentCategories={ this.props.parentCategories }
                                    attributes={ email }/>) }
                </div>
                <Pagination className="row justify-content-center">{ this.populatePagination() }</Pagination>
            </React.Fragment>
        );
    }
}

export default EmailList;